import { useCallback, useMemo, useState } from 'react';
import { Appointment } from 'vl-common/src/schemas/shared';
import { useTwilioWS } from './twilioWS';

const useClinicianChanged = (appointment: Appointment) => {
  const [newClinicianName, setNewClinicianName] = useState<string>();
  // track status and disconnect messages from the other party
  const onControlMessage = useCallback((msg: Record<string, any>) => {
    if ('clinicianChangedFrom' in msg && 'clinicianChangedTo' in msg) {
      setNewClinicianName(msg.newClinicianName);
    }
  }, []);

  useTwilioWS(
    appointment,
    useMemo(() => ({ onControlMessage }), [onControlMessage])
  );

  return [newClinicianName, setNewClinicianName] as const;
};

export default useClinicianChanged;
